<script>
import {defineComponent} from 'vue'
import TicketSidebar from "@/components/Tickets/widgets/TicketSidebar.vue";

export default defineComponent({
  name: "TicketLayouts",
  props: {
    title: {
      type: String,
      default: 'Sidebar'
    },
    sidebarItem: {
      type: Object,
      default: null
    },
    sidebarFields: {
      type: Array,
      default: () => []
    },
    sidebarLoading: {
      type: Boolean,
      default: false
    },
    sidebarMode: {
      type: String,
      default: 'form'
    }
  },
  components: {TicketSidebar},
  methods: {
    handleSidebarSave(formData) {
      this.$emit('sidebar-save', formData)
    },
    handleSidebarClose() {
      this.$emit('sidebar-close')
    }
  }
})
</script>

<template>
  <div class="layout">
    <slot></slot>
    <TicketSidebar
        v-bind:title="$props.title"
        :item="sidebarItem"
        :fields="sidebarFields"
        :is-loading="sidebarLoading"
        :mode="sidebarMode"
        @save="handleSidebarSave"
        @close="handleSidebarClose"
    >
      <template #custom-content="{ item, close }">
        <slot name="sidebar-custom-content" :item="item" :close="close"></slot>
      </template>
    </TicketSidebar>
  </div>
</template>

<style scoped lang="scss">
.layout {
  overflow-y: hidden !important;
}
</style>